module.exports = __webpack_public_path__ + "static/media/digital-signage-img2.3edb1e52.jpg";